(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["AdblockDetector"] = factory();
	else
		root["AdblockDetector"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Cookie = exports.VERSION = undefined;
	
	var _package = __webpack_require__(1);
	
	var _package2 = _interopRequireDefault(_package);
	
	var _constants = __webpack_require__(2);
	
	var _detector = __webpack_require__(3);
	
	var _detector2 = _interopRequireDefault(_detector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {};
	
	_extend(config, _constants.DEFAULTS, window.__VOONTO__.lookup(_constants.CONFIG_NAMESPACE), {
	  userType: window.__VOONTO__.getUserType(),
	  device: window.__VOONTO__.lookup('vocento.__PROVIDER__.adbd.deviceType'),
	  countryCode: window.__VOONTO__.lookup('vocento.__PROVIDER__.adbd.geo.countryCode')
	});
	
	new _detector2.default(config);
	
	var VERSION = exports.VERSION = _package2.default.version;
	
	var Cookie = exports.Cookie = {
	  NAME: _constants.COOKIE_NAME,
	  DOMAIN: _constants.COOKIE_DOMAIN
	};
	
	/* Private */
	
	function _extend() {
	  var _arguments = arguments;
	
	  for (var i = 1; i < arguments.length; i++) {
	    Object.keys(arguments[i]).forEach(function (key) {
	      _arguments[0][key] = _arguments[i][key];
	    });
	  }
	
	  return arguments[0];
	}

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = {
		"name": "adbd",
		"version": "3.0.5",
		"description": "",
		"main": "./src/index.js",
		"scripts": {
			"test": "./node_modules/.bin/mocha tests/**/*-spec.js --reporter mocha-junit-reporter --compilers js:babel-core/register",
			"test-dev": "./node_modules/.bin/mocha tests/**/*-spec.js --watch --compilers js:babel-core/register",
			"start": "webpack-dev-server",
			"build": "./node_modules/webpack/bin/webpack.js"
		},
		"author": "Iván Pérez <ivanperez@vocento.com>",
		"license": "SEE LICENSE IN LICENSE.md",
		"devDependencies": {
			"babel-core": "^6.17.0",
			"babel-loader": "^6.2.5",
			"babel-polyfill": "^6.16.0",
			"babel-preset-es2015": "^6.16.0",
			"chai": "^3.5.0",
			"chalk": "^1.1.3",
			"html-webpack-plugin": "^2.24.1",
			"jsdom": "^9.12.0",
			"is_js": "^0.9.0",
			"json-loader": "^0.5.4",
			"mocha": "^3.1.0",
			"mocha-junit-reporter": "^1.13.0",
			"mocha-loader": "^1.0.0",
			"webpack": "^1.13.3",
			"webpack-shell-plugin": "^0.4.3"
		}
	};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CONFIG_NAMESPACE = exports.CONFIG_NAMESPACE = 'vocento.config.adbd';
	
	var COOKIE_NAME = exports.COOKIE_NAME = '__adbd__';
	var COOKIE_DOMAIN = exports.COOKIE_DOMAIN = '.' + window.vocento.site.tlddomain; // NOTE: tldDomain to set as PATH parameter when save the cookie
	
	var EMBED_LAYER_PARAM = exports.EMBED_LAYER_PARAM = 'layer.html'; // NOTE: Final of the URL to get LAYER content
	var EMBED_MODAL_PARAM = exports.EMBED_MODAL_PARAM = 'modal.html'; // NOTE: Final of the URL to get MODAL content
	
	var EMBED_CONTAINER_SELECTOR = exports.EMBED_CONTAINER_SELECTOR = '[data-voc-adbd-layer]'; // NOTE: Selector to find the container where embed content
	var ADBLOCK_READY_NS = exports.ADBLOCK_READY_NS = 'adbd:ready';
	
	var DetectorType = exports.DetectorType = Object.freeze({
	  FILE: 'file'
	});
	
	var BehaviorTypes = exports.BehaviorTypes = Object.freeze({
	  REDIRECT: 'redirect',
	  EMBED: 'embed'
	});
	
	var DEFAULTS = exports.DEFAULTS = {
	  disabledUserTypes: ['trial', 'suscriptor'],
	  disabledCountries: ['ALL', '!ES'], // NOTE: all but Spain
	  disabledDevices: [],
	  strategies: [{
	    type: 'file',
	    config: {
	      traps: []
	    }
	  }],
	  behavior: {
	    type: 'embed',
	    url: '/', // NOTE: url used to redirect or get the alert content
	    queryString: '', // NOTE: querystring to append the url
	    delay: 5 }
	};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _behavior = __webpack_require__(4);
	
	var _behavior2 = _interopRequireDefault(_behavior);
	
	var _factory = __webpack_require__(5);
	
	var _factory2 = _interopRequireDefault(_factory);
	
	var _constants = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _window = window,
	    RSVP = _window.RSVP;
	
	var Detector = function Detector(_ref) {
	  var disabledUserTypes = _ref.disabledUserTypes,
	      disabledCountries = _ref.disabledCountries,
	      disabledDevices = _ref.disabledDevices,
	      strategies = _ref.strategies,
	      behavior = _ref.behavior,
	      userType = _ref.userType,
	      device = _ref.device,
	      countryCode = _ref.countryCode;
	
	  _classCallCheck(this, Detector);
	
	  this.options = { disabledUserTypes: disabledUserTypes, disabledCountries: disabledCountries, disabledDevices: disabledDevices, strategies: strategies, behavior: behavior, userType: userType, device: device, countryCode: countryCode };
	  this.behavior = new _behavior2.default(this.options.behavior);
	  this.strategies = [];
	
	  _init.call(this);
	};
	
	exports.default = Detector;
	
	/* Private */
	
	function _init() {
	  var _this = this;
	
	  this.options.strategies.forEach(function (strategy) {
	    _this.strategies.push(_factory2.default.create(strategy.type, strategy.config));
	  });
	
	  _findAdblocker.call(this);
	}
	
	function _hasNoStrategies() {
	  return this.strategies.length === 0;
	}
	
	function _isDisabledUserType() {
	  var _this2 = this;
	
	  return this.options.userType !== '' && this.options.disabledUserTypes.find(function (type) {
	    return type === _this2.options.userType;
	  });
	}
	
	function _isDisabledCountry() {
	  var _this3 = this;
	
	  return this.options.countryCode !== '' && (this.options.disabledCountries.find(function (type) {
	    return type === _this3.options.countryCode;
	  }) || this.options.disabledCountries.find(function (type) {
	    return type === 'ALL';
	  }) && !this.options.disabledCountries.find(function (type) {
	    return type === '!' + _this3.options.countryCode;
	  }));
	}
	
	function _isDisabledDevice() {
	  var _this4 = this;
	
	  return this.options.device !== '' && this.options.disabledDevices.find(function (type) {
	    return type === _this4.options.device;
	  });
	}
	
	function _findAdblocker() {
	  var _this5 = this;
	
	  this.strategies.forEach(function (strategy) {
	    RSVP.all(strategy.promises).then(function () {
	      return window.__VOONTO__.promised(_constants.ADBLOCK_READY_NS, false);
	    }).catch(function () {
	      if (_hasNoStrategies.call(_this5) || _isDisabledUserType.call(_this5) || _isDisabledCountry.call(_this5) || _isDisabledDevice.call(_this5)) {
	        window.__VOONTO__.promised(_constants.ADBLOCK_READY_NS, true);
	        return;
	      }
	
	      // NOTE: adblocker detected
	      window.__VOONTO__.when('voonto:ready').then(function () {
	        /* FUTURE: This condition avoids the REDIRECT behavior, due to this,
	         * in pages that the adbd should not be executed, the adbd.js should
	         * not be loaded.
	         */
	        if (window.Voonto.$(_constants.EMBED_CONTAINER_SELECTOR).length) {
	          _this5.behavior.init();
	        }
	      });
	      window.__VOONTO__.promised(_constants.ADBLOCK_READY_NS, true);
	    });
	  });
	}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(2);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _window = window,
	    Cookies = _window.Cookies;
	
	/**
	 * Clase que se encargará de ejecutar acciones para que se desactiven
	 */
	
	var Behavior = function () {
	  function Behavior(_ref) {
	    var type = _ref.type,
	        url = _ref.url,
	        queryString = _ref.queryString,
	        delay = _ref.delay;
	
	    _classCallCheck(this, Behavior);
	
	    this.options = { type: type, url: url, queryString: queryString, delay: delay };
	  }
	
	  _createClass(Behavior, [{
	    key: 'init',
	    value: function init() {
	      switch (this.options.type) {
	        case _constants.BehaviorTypes.REDIRECT:
	          this.redirect();
	          break;
	        case _constants.BehaviorTypes.EMBED:
	          this.embed();
	          break;
	        default:
	          throw Error('[AdblockDetector] Missing behavior configuration');
	      }
	    }
	
	    /**
	     * Redirect behavior
	     */
	
	  }, {
	    key: 'redirect',
	    value: function redirect() {
	      var _this = this;
	
	      // NOTE: if cookie exist redirect without delay
	      if (Cookies.get(_constants.COOKIE_NAME)) {
	        window.location = this.options.url;
	      } else {
	        // NOTE: if cookie NOT exist redirect with delay
	        setTimeout(function () {
	          Cookies.set(_constants.COOKIE_NAME, _constants.COOKIE_NAME, { path: _constants.COOKIE_DOMAIN });
	          window.location = _this.options.url;
	        }, this.options.delay * 1000);
	      }
	    }
	
	    /**
	     * Embed behavior(layer and popup)
	     */
	
	  }, {
	    key: 'embed',
	    value: function embed() {
	      var _this2 = this;
	
	      var ajaxCall;
	      // If cookie exist show layer
	      if (Cookies.get(_constants.COOKIE_NAME)) {
	        ajaxCall = this.getTemplate(this.options.url + _constants.EMBED_LAYER_PARAM);
	        ajaxCall.then(function (data) {
	          window.Voonto.$(_constants.EMBED_CONTAINER_SELECTOR).html(data);
	        });
	      } else {
	        // If cookie NOT exist show popup
	        ajaxCall = this.getTemplate(this.options.url + _constants.EMBED_MODAL_PARAM);
	        ajaxCall.then(function (data) {
	          setTimeout(function () {
	            var modal$ = window.Voonto.$(data);
	            window.Voonto.$(_constants.EMBED_CONTAINER_SELECTOR).prepend(modal$);
	            modal$.modal('show');
	            Cookies.set(_constants.COOKIE_NAME, _constants.COOKIE_NAME, { expires: 7, path: _constants.COOKIE_DOMAIN });
	          }, _this2.options.delay * 1000);
	        });
	      }
	      ajaxCall.catch(function (jqXHR, textStatus, errorThrown) {
	        throw new Error(errorThrown);
	      });
	    }
	  }, {
	    key: 'getTemplate',
	    value: function getTemplate(url) {
	      return window.Voonto.$.ajax({ url: url + this.options.queryString });
	    }
	  }]);
	
	  return Behavior;
	}();
	
	exports.default = Behavior;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _file = __webpack_require__(6);
	
	var _file2 = _interopRequireDefault(_file);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _strategies = {};
	_strategies.file = _file2.default;
	
	var Factory = Object.freeze({
	  create: function create(type, config) {
	    if (!_strategies.hasOwnProperty(type)) {
	      throw Error('[AdBlockDetector] detector type not found');
	    }
	    return new _strategies[type](config);
	  }
	});
	
	exports.default = Factory;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _abstract = __webpack_require__(7);
	
	var _abstract2 = _interopRequireDefault(_abstract);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FileStrategy = function (_AbstractStrategy) {
	  _inherits(FileStrategy, _AbstractStrategy);
	
	  function FileStrategy(_ref) {
	    var traps = _ref.traps;
	
	    _classCallCheck(this, FileStrategy);
	
	    var _this = _possibleConstructorReturn(this, (FileStrategy.__proto__ || Object.getPrototypeOf(FileStrategy)).apply(this, arguments));
	
	    _this.promises = traps.map(function (url) {
	      return window.__VOONTO__.load(url);
	    });
	    return _this;
	  }
	
	  return FileStrategy;
	}(_abstract2.default);
	
	exports.default = FileStrategy;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(2);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AbstractStrategy = function AbstractStrategy(config) {
	  _classCallCheck(this, AbstractStrategy);
	
	  this.type = _constants.DetectorType.FILE;
	  this.config = config;
	  this.promises = [];
	};
	
	exports.default = AbstractStrategy;

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// adbd.js